import React, {useEffect, useState} from 'react'

export default function ToasterSignIn() {
    const [isToasterVisible, setIsToasterVisible] = useState(false)

    useEffect(() => {
      // Show toaster when component is mounted
      setIsToasterVisible(true)
  
      // Hide toaster after 2 seconds
      const timeout = setTimeout(() => {
        setIsToasterVisible(false)
      }, 5000)
  
      // Clean up timeout on component unmount
      return () => clearTimeout(timeout)
    }, [])
  
    return (
      <div>
        {isToasterVisible && (
          <div id='toaster_container'>
            <h3 id='toaster_heading' >Welcome Back!</h3>
            <p id='toaster_message' >You have successfully signed in.</p>
          </div>
        )}
      </div>
    )
  }
